import React, { useState, useEffect } from "react";
import { sendToAndroid } from "../services/androidBridge";
import Event from "./Event";
import {transferListLanguageOptions} from "./dropdown/dropdown-data";

const EventList = () => {
    const [eventList, setEventList] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState(null);
    const [, setAccountList] = useState([]);

    const [confirmMessage, setConfirmMessage] = useState("notLoaded");
    const [successMessage, setSuccessMessage] = useState("notLoaded");
    const [jwt, setJwt] = useState();
    const [, setUserName] = useState("");

    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [closeLoading, setCloseLoading] = useState(false);
    const [title, setTitle] = useState();
    const [warning] = useState("");
    const [onConfirm, setOnConfirm] = useState("");
    const [isFirst, setIsFirst] = useState(true);
    const [, setExtractedUrl] = useState("");



    const handleFirstRender = (request) => {
        if (!isFirst) {
            sendDataToAndroid(request);
        }
        setIsFirst(false);
    };

    useEffect(() => {
        sendDataToAndroid("first");

        window.receiveDataFromAndroid = (data) => {
            var dataString = JSON.stringify(data);
            var obj = JSON.parse(dataString);

            if (JSON.parse(obj.request).name === "accountList") {
                if (
                    obj.response !== undefined &&
                    JSON.parse(obj.response).data !== undefined
                ) {
                    let uniqueAccountList = [];
                    JSON.parse(JSON.parse(obj.response).data).forEach((account) => {
                        uniqueAccountList = [
                            ...uniqueAccountList,
                            { label: account.accounts, value: account.accounts },
                        ];
                        setAccountList([...uniqueAccountList]);
                    });
                }
            }

            if (JSON.parse(obj.request).name === "confirmResponse") {
                setOnConfirm("true");
            }

            if (JSON.parse(obj.request).name === "jwt") {
                setJwt(JSON.parse(obj.response).data);
            }

            if (JSON.parse(obj.request).name === "response") {
                const urlFromResponse = JSON.parse(obj.request).url;
                setExtractedUrl(urlFromResponse);

                handleDataBasedOnUrl(urlFromResponse, JSON.parse(obj.response).data);
            }

            if (JSON.parse(obj.request).name === "userName") {
                setUserName(JSON.parse(obj.response).data);
            }
        };
    }, []);

    const handleDataBasedOnUrl = (url, responseData) => {
        console.log("method called " + url);
        if (url.includes("eventApp/services/eventsList")) {
            const { data, status,desc } = JSON.parse(responseData);
            console.log(JSON.stringify(data));
            if (status === true) {
                setEventList(data.items);
            }
            else {
                setErrorMessage(desc);
                setSuccessMessage("");
            }
        }
    };
    useEffect(() => {
        if (!isFirst) {
            setTitle(transferListLanguageOptions[jwt][7]);
        }
        setIsFirst(false);
    }, [jwt]);
    useEffect(() => {
        handleFirstRender("title");
    }, [title]);

    useEffect(() => {
        handleFirstRender("confirm");
    }, [confirmMessage]);
    useEffect(() => {
        handleFirstRender("success");
    }, [successMessage]);

    useEffect(() => {
        handleFirstRender("warning");
    }, [errorMessage]);

    useEffect(() => {
        handleFirstRender("openLoading");
    }, [loading]);

    useEffect(() => {
        handleFirstRender("openLoading");
        if (closeLoading) {
            setLoading(false);
            setCloseLoading(false);
        }
    }, [closeLoading]);

    useEffect(() => {
        handleFirstRender("warning");
    }, [warning]);

    useEffect(() => {
        if (onConfirm !== "") {
            handleFirstRender("request");
        }
    }, [onConfirm]);

    useEffect(() => {
        sendDataToAndroid("events");
    }, []);

    const sendDataToAndroid = (name) => {
        var transferData = {
            transferData: [],
        };
        if (name === "return") {
            transferData = {
                transferData: [
                    {
                        type: "return",
                        request: { name: "graphData" },
                        response: {},
                        name: "",
                    },
                ],
            };
        } else if (name === "title") {
            transferData = {
                transferData: [
                    {
                        type: "title",
                        request: { name: "title" },
                        response: { data: title },
                        name: "",
                    },
                ],
            };
        } else if (name === "first") {
            transferData = {
                transferData: [
                    {
                        type: "first",
                        request: { name: "first" },
                        response: {},
                        name: "",
                    },
                ],
            };
        } else if (name === "confirm") {
            transferData = {
                transferData: [
                    {
                        type: "confirm",
                        request: { name: "confirm" },
                        response: { data: confirmMessage },
                        name: "",
                    },
                ],
            };
        } else if (name === "openLoading") {
            transferData = {
                transferData: [
                    {
                        type: "openLoading",
                        request: { name: "openLoading" },
                        response: { data: loading },
                        name: "",
                    },
                ],
            };
        } else if (name === "closeLoading") {
            transferData = {
                transferData: [
                    {
                        type: "closeLoading",
                        request: { name: "closeLoading" },
                        response: { data: closeLoading },
                        name: "",
                    },
                ],
            };
        } else if (name === "warning") {
            transferData = {
                transferData: [
                    {
                        type: "warning",
                        request: { name: "warning" },
                        response: { data: errorMessage },
                        name: "",
                    },
                ],
            };
        } else if (name === "error") {
            transferData = {
                transferData: [
                    {
                        type: "error",
                        request: { name: "error" },
                        response: { data: errorMessage },
                        name: "",
                    },
                ],
            };
        } else if (name === "success") {
            transferData = {
                transferData: [
                    {
                        type: "success",
                        request: { name: "success" },
                        response: { data: successMessage },
                        name: "",
                    },
                ],
            };
        }
        else if (name === "events") {
            console.log("Data sent to fetch school");
            transferData = {
                transferData: [
                    {
                        type: "requestPostNoLoading",
                        request: { name: "eventApp/services/eventsList" },
                        response: { data: { event: "all" } },
                        name: "",
                    },
                ],
            };
        }
        sendToAndroid(transferData);
        setConfirmMessage("");
        setOnConfirm("");
        setErrorMessage("");
    };

    const handleEventSelect = (event) => {
        setSelectedEvent(event);
    };

    const handleBackToHome = () => {
        setSelectedEvent(null);
    };

    return (
        // <ComingSoon/>

        selectedEvent ? (
            <Event event={selectedEvent} onBack={handleBackToHome} />
        ) : (
            <div className="service-screen w-full max-w-md mx-auto p-4">
                {eventList.length === 0 ? (
                    // Display message if the list is empty
                    <div className="rounded-xl border border-slate-200 bg-slate-50 p-6 text-center">
                        <p className="text-lg font-medium text-gray-700">There are no active events.</p>
                        <p className="text-sm text-gray-500 mt-1">Please check back soon!</p>
                    </div>
                ) : (
                    // Display the list of events if not empty
                    <div className="space-y-3">
                        {eventList.map((event) => (
                            <div
                                key={event.id}
                                className="cursor-pointer rounded-xl border border-slate-200 bg-white p-4 shadow-sm transition hover:border-[#7eacdf] hover:bg-[#f8fbff] hover:shadow-md"
                                onClick={() => handleEventSelect(event)}
                            >
                                <h2 className="text-lg font-semibold">{event.eventName}</h2>
                                <p className="text-sm text-gray-600">{event.eventDate}</p>
                                <p className="text-sm text-gray-500">{event.location}</p>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        )
    );
};

export default EventList;
